import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/base/SEO';
import DetailHero from './components/DetailHero';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RelatedAndFAQ from './components/RelatedAndFAQ';
import ArticleCTA from './components/ArticleCTA';
import ArticleSchema from '@/components/base/ArticleSchema';
import { articleDetails } from '@/mocks/article';
import { categoryComics } from '@/mocks/category';
import type { ArticleDetail } from '@/mocks/article';

function getArticleById(id: number): ArticleDetail | null {
  if (Object.prototype.hasOwnProperty.call(articleDetails, id)) {
    return articleDetails[id];
  }

  if (id >= 101) {
    const comic = categoryComics.find((c) => c.id === id);
    if (!comic) return null;

    const mappedId = ((id - 100 - 1) % 6) + 1;
    const baseArticle = articleDetails[mappedId];
    if (!baseArticle) return null;

    return {
      ...baseArticle,
      id: comic.id,
      title: comic.title,
      author: comic.author,
      rating: parseFloat(comic.rating),
      category: baseArticle.category,
      categorySlug: comic.category,
      status: comic.status,
      chapters: comic.chapters,
    };
  }

  return null;
}

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = Number(id);
  const article = getArticleById(articleId);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 flex items-center justify-center h-64">
          <p className="text-foreground-500">漫画不存在或已下架</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <SEO
        title={`${article.title}韩国漫画无删减下拉式-51漫画网`}
        description={`51漫画网提供${article.title}无删减韩国漫画下拉式阅读，${article.description}`}
        keywords={`${article.title},韩国漫画,无删减漫画,下拉式漫画,${article.category}韩漫,51漫画网`}
        canonical={`https://51manhua.com/article/${article.id}`}
      />
      <ArticleSchema article={article} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-16">
            <Breadcrumb items={[
              { label: '首页', path: '/' },
              { label: article.category, path: `/category/${article.categorySlug}` },
              { label: article.title },
            ]} />
          </div>
          <DetailHero article={article} />
          <AboutSection article={article} />
          <CommentsSection />
          <RelatedAndFAQ />
          <ArticleCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}